<template>
  <v-app id="wrap-project">

    <loading :active.sync="busy"/>

    <div v-if="!busy&&!!response" id="content-wrap">

      <!-- Header -->
      <header id="header-project">
        <div id="project-title">
          <div id="btn-menu-wrap">
            <div id="btn-menu">
              <v-btn icon dark @click="menu_bar_visible=true">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </div>
          </div>
          <router-link tag="div"
            class="bt-menu"
            :to="{name:'watching-projects'}">
            <v-btn depressed color="#ffbf51" small>Watching</v-btn>
            <span>&nbsp;/&nbsp;</span> 
          </router-link>
          
          <div id="bt-subtitle">{{ project_info.title }}</div>

          <div>({{ project_info.owner.name }})</div>
          
          <div id="btn-more">
            <v-menu offset-y>
              <template v-slot:activator="{ on: { click } }">
                <div v-on:click.stop.prevent="click">
                  <v-btn small icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item v-if="status==1" 
                  @click.stop="responseInvitation(0)">
                  <span>프로젝트 숨김</span>
                </v-list-item>
                <v-list-item v-if="status==0"
                  @click.stop="responseInvitation(1)">
                  <span>프로젝트 열람</span>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div id="btn-account">
          <div id="comment-btn">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" v-if="!comments_on"
                  @click="$router.replace({ query: { comments: 'true' } })">
                  <v-icon>mdi-message-reply-text</v-icon>
                </v-btn>
                <v-btn icon v-on="on" v-else
                  @click="$router.replace({ query: null })">
                  <v-icon color="primary">mdi-message-reply-text</v-icon>
                </v-btn>
              </template>
              <span v-if="comments_on">코멘트 끄기</span>
              <span v-else>코멘트 켜기</span>
            </v-tooltip>
          </div>

          <account-menu></account-menu>
        </div>

      </header>

      <div id="content">

        <!-- Fab drawer -->
        <div id="fab-drawer">
          <v-btn v-if="drawer_open==1" @click="drawer_open=0"
            fab small class="white--text" color="#ff5193">
            <v-icon >mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn v-if="drawer_open==0" @click="drawer_open=1"
            fab small class="white--text" color="#ff5193">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <!-- Left pane -->
        <div id="content-left" v-show="!fixed_pane">

          <div v-show="view_tree">
            <v-tooltip right >
              <template v-slot:activator="{ on }">
                <div class="tree-tool" v-on="on"
                  @click="reloadTree()">
                  <v-icon small>mdi-reload</v-icon>
                </div>
              </template>
              <span>{{ $t('project.reload') }}</span>
            </v-tooltip>
          </div>

          <!-- Tree -->
          <section id="tree" v-show="view_tree">
            <app-tree ref="tree"></app-tree>
          </section>

          <!-- Project Note -->
          <section id="note" v-show="!view_tree"
            :style="{ 'width': left_margin_width + 'px'}">
            <app-project-note/>
          </section>
        </div>

        <!-- Fab for note -->
        <div id="fab-note" v-if="!fixed_pane">
          <v-btn @click="view_tree=!view_tree"
            fab dark color="#ff5193">
            <v-icon v-if="view_tree">mdi-file-document</v-icon>
            <v-icon v-else>mdi-vector-polyline</v-icon>
          </v-btn>
        </div>

        <multipane id="pane-wrap">
          <div id="pane-left" v-resize="onResize"
            :class="{ 'pane-left-fixed': !drawer_open, 'pane-left-removed': fixed_pane }"></div>
          <multipane-resizer v-show="!!drawer_open&&draggable"></multipane-resizer>
          <div v-show="!!drawer_open" id="pane-right" 
            :class="{ 'pane-right-fixed': fixed_pane, 'pane-right-removed': !drawer_open }">
            <drawer :comments_on="comments_on"></drawer>
          </div>
        </multipane>

      </div>

    </div>

    <!-- Modals -->
    <menu-bar
      :dialog.sync="menu_bar_visible">
    </menu-bar>

    <!-- Pending dialog -->
    <template>
      <v-dialog v-model="pending_dialog" width="400px" persistent>
        <v-card>
          <v-card-title class="card-title">
            <span>프로젝트를 열람하시겠습니까?</span>
            <v-btn icon @click="closePendingDialog()"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div>"{{ project_info.title }}" 프로젝트를 열람하시려면 '열람'을, 열람하지 않고 숨기시려면 '숨김'을 선택하세요.</div>
            <div>프로젝트 리스트에서 언제든 숨김을 해제할 수 있습니다.</div>
          </v-card-text>
          <v-card-actions>
            <v-btn text to="/watching-projects">
              프로젝트 리스트 보기
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed @click="responseInvitation(0)">
              숨김
            </v-btn>
            <v-btn depressed color="primary" @click="responseInvitation(1)">
              열람
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Multipane, MultipaneResizer } from 'vue-multipane'

import AppProjectNote from './Note.vue'

export default {

  metaInfo() {
    return {
      title: "Project-watching"
    }
  },

  components: {
    AppProjectNote,
    Multipane,
    MultipaneResizer,
  },

  data() {
    return {
      busy: false,

      drawer_open: 1,
      draggable: true,
      fixed_pane: false,
      left_margin_width: window.innerWidth - 400,

      view_tree: true,

      menu_bar_visible: false,
      pending_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      project_info: 'watching/project_info',
    }),

    proj_id() {
      return parseInt(this.$route.params.id)
    },

    response() {
      return !!this.project_info ? this.project_info.response : 0
    },

    status() {
      return !!this.project_info ? this.project_info.status : 0
    },

    query() {
      return this.$route.query
    },

    query_comments() {
      return this.$route.query.comments
    },

    comments_on() {
      return this.$route.query.comments == 'true' ? true : false
    },
  },

  watch: {

    proj_id: {
      async handler() {
        await this.getProject()
      },
      immediate: true,
    },

    query_comments: {
      handler(val) {
        if (val!='true' && !!val) {
          this.$router.replace({ name: 'watching-project' })
        }
      },
      immediate: true
    },

    query: {
      handler(val) {
        if (this.drawer_open==0&&!!val) {
          this.drawer_open = 1
        }
      }
    },

    drawer_open(val) {
      this.calcDrawer()
    },

  },

  created() {
    this.resize()
    window.addEventListener("resize", this.resize)
    this.$store.commit("tree/setTreeMode", {
      mode: 'watching-project', 
      base: parseInt(this.$route.params.id)
    })
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  methods: {

    resize() {
      this.calcDrawer()
    },

    onResize({ width, height }) {
      this.left_margin_width = width
    },

    calcDrawer() {
      if (!!this.drawer_open) {
        if (window.innerWidth <= 800) {
          this.fixed_pane = true
          this.draggable = false
        } else {
          this.fixed_pane = false
          this.draggable = true
        }
      } else {
        this.draggable =  false
        this.fixed_pane = false
      }
    },

    async getProject() {
      this.busy = true
      try {
        await this.$store.dispatch('watching/getProjects')
      } finally {
        let projs = this.$store.getters['watching/projects']
        let proj_ids = projs.map(v => v.proj_id)
        if (!projs.length || !proj_ids.includes(parseInt(this.$route.params.id))) {
          this.$router.replace({ name: 'watching-projects' })
        } else {
          try {
            await this.$store.dispatch('watching/getProject', parseInt(this.$route.params.id))
          } finally {
            let res = this.$store.getters['watching/project_info'].response
            if (res == 0) { this.pending_dialog = true }
          }
        }
      }
      this.busy = false
    },

    reloadTree() {
      this.$refs.tree.init_unit()
    },

    closePendingDialog() {
      this.pending_dialog = false
      this.$router.replace({ name: 'watching-projects' })
    },

    async responseInvitation(opt) {
      await this.$store.dispatch('watching/responseInvitation', {
        proj_id: this.proj_id,
        status: opt,
      })
      this.pending_dialog = false
      if (!opt) { this.$router.replace({ name: 'watching-projects' }) }
    },
  }

}
</script>

<style scoped>

  /* Layout */
  #wrap-project {
    background-color: #ffffff;
    height: 100vh;
    overflow-y: hidden;
  }

  #content-wrap {
    display: flex;
    flex-direction: column;
  }

/* Content */

  #content {
    position: relative;
    min-width: 400px;
  }

  #tree {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select:none;
    user-select:none;
    -o-user-select:none;
  }

  #content-left {
    height: calc(100vh - 60px);
    width: 100vw;
    position: relative;
    z-index: 1;
  }

  #fab-drawer {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 9;
  }

  #fab-note {
    position: absolute;
    left: 20px;
    bottom: 20px;
    z-index: 9;
  }

  .tree-tool {
    position: absolute;
    z-index: 100;
    top: 12px;
    left: 12px;
    cursor: pointer;
  }

  /* Header */

  #header-project {
    background-color: #ffffff;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #dde2e5 solid 1px;
    z-index: 9;
    min-width: 400px;
  }

  #project-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }

  #btn-menu-wrap {
    width: 70px;
    height: 100%;
  }
  
  #btn-menu {
    height: 100%;
    margin: 0 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ff5193;
  }

  #bt-subtitle{
    font-family: "Bree Serif", Roboto, 'Noto Sans', 'Noto Sans KR', "Apple SD Gothic Neo", sans-serif;
    font-size: 16pt;
    margin: 0 8px;
    transform: translateY(-2px);
  }

  #btn-more {
    margin-left: 8px;
  }

  #btn-account {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 20px;
  }

  #comment-btn {
    margin-right: 8px;
  }

  .card-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  #note {
    width: 100% !important;
    height: calc(100vh - 60px);
  }

  /* Pane */

  #pane-wrap {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 100vw;
    visibility: hidden;
    align-items: stretch;
  }

  #pane-left {
    width: calc(100vw - 400px);
    min-width: 200px;
  }

  .pane-left-removed, .pane-right-removed {
    width: 0px !important;
    min-width: 0px !important;
  }

  .pane-left-fixed, .pane-right-fixed {
    width: 100vw !important;
  }

  .multipane-resizer {
    width: 15px !important;
    visibility: visible !important;
    height: 100vh !important;
  }

  #pane-right {
    visibility: visible;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
    height: calc(100vh - 60px);
    background-color: #ffffff;
    flex-grow: 1;
    width: 400px;
    overflow-y: auto;
    transition: right .5s cubic-bezier(0.820, 0.085, 0.395, 0.895);
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/project-watching/Layout.vue